import React from "react";
import { Button, Popover, Text } from "@bookingcom/bui-react";
import { useUnifiedPriceTagPriceBreakdownController } from "./useUnifiedPriceTagPriceBreakdown.controller";
import { type UnifiedPriceTagPriceBreakdownProps } from "./UnifiedPriceTagPriceBreakdown";

export const UnifiedPriceTagPriceBreakdownDesktop = ({
  priceBreakdownTrigger,
  priceBreakdownTriggerProps,
  priceBreakdownContent,
  priceBreakdownOnOpen = () => {},
  priceBreakdownOnClose = () => {},
  priceBreakdownCloseAriaLabel
}: UnifiedPriceTagPriceBreakdownProps) => {
  const { contentTitle, showPriceBreakdown, setShowPriceBreakdown } = useUnifiedPriceTagPriceBreakdownController();

  if (!priceBreakdownTrigger || !priceBreakdownContent) {
    return;
  }

  return (
    <Popover
      position="bottom"
      active={showPriceBreakdown}
      onOpen={() => {
        setShowPriceBreakdown(true);
        priceBreakdownOnOpen();
      }}
      onClose={() => {
        setShowPriceBreakdown(false);
        priceBreakdownOnClose();
      }}
      closeAriaLabel={priceBreakdownCloseAriaLabel}
    >
      <Popover.Trigger>
        {(attributes) => (
          <Button
            variant="tertiary-neutral"
            size="medium"
            {...priceBreakdownTriggerProps}
            attributes={{
              ...priceBreakdownTriggerProps?.attributes,
              ...attributes
            }}
          >
            {priceBreakdownTrigger}
          </Button>
        )}
      </Popover.Trigger>
      <Popover.Content
        title={
          <Text variant="headline_3" tagName="h2">
            {contentTitle}
          </Text>
        }
        attributes={{
          style: { width: 360 },
          role: "dialog",
          "aria-modal": "true",
          "data-testid": "upt_price_breakdown_content"
        }}
      >
        {priceBreakdownContent}
      </Popover.Content>
    </Popover>
  );
};
